import "./PlanPausedModal.scss";
import Popup from "../../../atoms/Popup/Popup";
import Button from "../../../atoms/Button/Button";

interface Props {
  show: boolean;
  patientName?: string | null;
  planName?: string | null;
  onClose: () => void;
}

const PlanPausedModal = ({ show, patientName, planName, onClose }: Props) => {
  const who = patientName?.trim() || "This patient";
  const plan = planName?.trim();

  return (
    <Popup
      show={show}
      onClose={onClose}
      headerText="Patient plan is paused"
      closeOnOverlayClick
    >
      <div className="plan-paused-modal">
        <p className="plan-paused-modal-note">
          {who}&apos;s plan{plan ? `, ${plan},` : ""} is currently paused.
        </p>
        <p>
          Program progress and new assignments are on pause until the plan is
          resumed. You can still view their profile, records, and history.
        </p>
        <div className="popup-footer">
          <Button onClick={onClose}>Got it</Button>
        </div>
      </div>
    </Popup>
  );
};

export default PlanPausedModal;
